import React, { useEffect, useState } from 'react';
import {
    Form,
    Button,
    Spinner,
    Offcanvas,
    Stack
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useStatusChangeMutation } from './ordersApi';

const ChangeStatus = ({ idSum, onClearSelection, setLoading }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const navigate = useNavigate();
    const [status, setStatus] = useState('');
    const handleClose = () => setShow(false);
    const toggleShow = () => setShow((s) => !s);
    const [statusChange] = useStatusChangeMutation();

    const handleSubmit = async () => 
        {
        setButtonLoading(true);
        let { data } = await statusChange({ status: status, ordernos: idSum });
        
        if (data) 
            {
            setButtonLoading(false);
            setLoading(true);
            setShow(false); // Close the offcanvas
             onClearSelection?.();
            if (status === 'Pending'){
               navigate(`/order/list`, {
                state: {
                    status: "Pending",
                },
            });
        }
            
        }
    };

    return (
        <>
            <Button
                variant="primary"
                onClick={toggleShow}
                disabled={idSum.length == 0}
            >
                {t('Changer le statut')}
            </Button>
            <Offcanvas
                show={show}
                onHide={handleClose}
                backdrop="static"
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{t('Changer le statut')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('Changetheorderstatus')}</Form.Label>
                        <Form.Select
                            aria-label="Default"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option disabled value={''}>
                                {t('selectItem')}
                            </option>
                            <option value="Pending">En attente</option>
                            <option value="SAV">SAV</option>
                            <option value="Devis">Devis</option>
                            <option value="ToBeOrdered">À commander</option>
                            <option value="Commandé">Commandée</option>
                            <option value="Annulé">Annulée</option>
                        </Form.Select>
                    </Form.Group>

                    <Stack direction="horizontal" gap={3} className="mb-3">
                        <Button
                            variant="primary"
                            onClick={handleSubmit}
                            disabled={buttonLoading || !status}
                        >
                            {buttonLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {t('attribuerorder')}
                        </Button>
                        <Button
                            variant="secondary"
                            className=""
                            onClick={handleClose}
                        >
                            {t('Annuler')}
                        </Button>
                    </Stack>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ChangeStatus;